import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Service from "../../services/KebutuhanKhususService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataKebutuhanKhusus: [],
    dataKebutuhanKhususByID:[],
    showMessage:false,
    message:''
}


export const getDataKebutuhanKhusus = createAsyncThunk('ref/kebutuhankhusus',async (data, { rejectWithValue }) => {
    try {
        const response = await Service.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataKebutuhanKhususByID = createAsyncThunk('ref/pkebutuhankhususbyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await Service.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const kebutuhanKhususSlice = createSlice({
    name: 'kebutuhan_khusus',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataKebutuhanKhusus = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKebutuhanKhusus.fulfilled, (state, action) => {
                state.loading = false
                state.dataKebutuhanKhusus = action.payload
            })
            .addCase(getDataKebutuhanKhusus.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKebutuhanKhusus.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.data = action.payload
            })
            .addCase(getDataKebutuhanKhususByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataKebutuhanKhususByID = action.payload
            })
            .addCase(getDataKebutuhanKhususByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataKebutuhanKhususByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataKebutuhanKhususByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = kebutuhanKhususSlice.actions

export default kebutuhanKhususSlice.reducer
